import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '982787274682165'

function loadPixelScript() {
  if (window.fbq) return

  const n: any = (window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  const initialized = useRef(false)

  useEffect(() => {
    if (!initialized.current) {
      loadPixelScript()
      initialized.current = true
    }
  }, [])

  return {
    pageView: () => window.fbq?.('track', 'PageView'),
    trackAddToCart: () => window.fbq?.('track', 'AddToCart'),
  }
}
